package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.CurrencyDomain

@Serializable
enum class CurrencyDto {
    @SerialName("RUB") RUB,
    @SerialName("USD") USD,
    @SerialName("IDR") IDR,
    @SerialName("CNY") CNY
}

fun CurrencyDto.toDomain() = when (this) {
    CurrencyDto.CNY -> CurrencyDomain.CNY
    CurrencyDto.IDR -> CurrencyDomain.IDR
    CurrencyDto.RUB -> CurrencyDomain.RUB
    CurrencyDto.USD -> CurrencyDomain.USD
}